import { render, staticRenderFns } from "./SettingsPortraitCover.vue?vue&type=template&id=146aa7e2&"
import script from "./SettingsPortraitCover.vue?vue&type=script&lang=js&"
export * from "./SettingsPortraitCover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports